import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import CrediDebitNoteComponent from '../components/credit-debit-note.component';
import { creditDebitNotes } from '../../../../../../redux/credit-debit-notes/action';
import { selectCreditDebitNotesQueryItems } from '../../../../../../redux/credit-debit-notes/selector';
import storePersist from '../../../../../../redux/storePersist';
import { selectSuppliersListItems } from '../../../../../../redux/suppliers/selector';
import { suppliers } from '../../../../../../redux/suppliers/action';
import { stores } from '../../../../../../redux/stores/action';
import { selectStoresListItems } from '../../../../../../redux/stores/selector';
import { selectGrnsListItems } from '../../../../../../redux/grns/selector';
import { grns } from '../../../../../../redux/grns/action';
import { stockTransfers } from '../../../../../../redux/stock-transfers/action';
import { selectStockTransfersListItems } from '../../../../../../redux/stock-transfers/selector';
import { orders } from '../../../../../../redux/orders/action';
import { selectOrdersListItems } from '../../../../../../redux/orders/selector';

const ManagementCreditDebitNote = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const creditDebitNotesQuery = useSelector(selectCreditDebitNotesQueryItems)
  const supplierListItems = useSelector(selectSuppliersListItems)
  const storeListItems = useSelector(selectStoresListItems)
  const grnListItems = useSelector(selectGrnsListItems)
  const stockTransfersListItems = useSelector(selectStockTransfersListItems)
  const ordersListItems = useSelector(selectOrdersListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectCrediDebitNotes, setSelectCrediDebitNotes] = useState<any>([])
  const librariesItems = storePersist?.get("library")?.current;

  const fetchCreditDebitNotesQueryById = () => {
    dispatch(creditDebitNotes.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/credit-debit-notes/query`,
      entity: 'creditDebitNotes',
      jsonData: {
        Records: [
          {
            Id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectCrediDebitNotes({ ...selectCrediDebitNotes, [field]: event })
  }

  useEffect(() => {
    dispatch(stores.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`,
      entity: 'stores',
      jsonData: {}
    })).then(() => {
      dispatch(suppliers.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/scm/e-procurement/suppliers/list`,
        entity: 'suppliers',
        jsonData: {}
      }))
    }).then(() => {
      dispatch(grns.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/scm/e-procurement/grns/list`,
        entity: 'grns',
        jsonData: {}
      }))
    }).then(() => {
      dispatch(stockTransfers.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/scm/stock-control/stock-transfers/list`,
        entity: 'stockTransfers',
        jsonData: {}
      }))
    }).then(() => {
      dispatch(orders.list({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/management/orders/list`,
        entity: 'orders',
        jsonData: {}
      }))
    }).then(() => {
      if (parmas?.id > 0) {
        fetchCreditDebitNotesQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []
  )

  useEffect(() => {
    if (isQuery) {
      setSelectCrediDebitNotes(creditDebitNotesQuery?.result?.items)
    }
  }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(creditDebitNotes.resetAction({ actionType: 'update' }))
      await dispatch(creditDebitNotes.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/credit-debit-notes`,
        entity: 'creditDebitNotes',
        jsonData: {
          Records: [
            selectCrediDebitNotes
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      await dispatch(creditDebitNotes.resetAction({ actionType: 'create' }))
      await dispatch(creditDebitNotes.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/credit-debit-notes`,
        entity: 'creditDebitNotes',
        jsonData: {
          Records: [
            selectCrediDebitNotes
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = () => {
    navigate('/management/e-applications/accounts/credit-debit-notes')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <CrediDebitNoteComponent
          handleInnerFormChange={handleInnerFormChange}
          selectCrediDebitNotes={selectCrediDebitNotes}
          referenceTypeList={librariesItems?.CreditDebitNoteReferenceType}
          documentTypeList={librariesItems?.CreditDebitNoteDocumentType}
          grnsList={grnListItems?.result?.items}          
          stockTransfersList={stockTransfersListItems?.result?.items}
          ordersList={ordersListItems?.result?.items[0]?.Message}
          supplierNameList={supplierListItems?.result?.items}
          storeNameList={storeListItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
}

export default ManagementCreditDebitNote;